import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TrendUp icon
 *
 * @category Business
 */
const TrendUp = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M27.522 10.448c-3.149-6.239-6.87-.597-7.374 3.746-.176.9-.457 1.076-1.054.21-2.212-3.5-5.583-2.001-6.812 1.686-.34.76-.456 2.739-1.557 1.428-2.071-2.587-5.43-1.616-6.683 1.252-1.814 3.406-.55 10.43 4.132 10.183 1.276-.163 2.317-1.112 2.973-2.177.269-.386.573-1.182.96-1.252.48.047.866 1.147 1.252 1.568 1.264 1.896 3.64 2.318 5.185.363.866-.784 1.147-2.47 1.861-3.113.188-.024.387.421.644 1.041.667 2.072 2.915 4.495 4.998 2.622 3.85-4.307 3.441-12.454 1.569-17.37l-.082-.187zm-17.51 16.047c-.785 1.136-2.412 1.71-3.582.785-2.318-1.791-2.505-5.83-1.218-8.276 1.534-2.973 4.425-2.294 5.49.609.843 1.955.609 5.068-.574 6.73zm8.216-.538c-1.334 2.317-3.242 1.99-4.39-.281-1.497-2.81-1.497-7.433 0-10.23 2.05-3.863 4.624-1.065 5.315 2.037.667 2.505.41 6.145-.808 8.298l-.105.176zm8.229-.515c-1.967 4.4-4.144 1.03-4.846-1.931-.901-3.406-.878-7.995.246-11.413.491-1.252 1.229-3.534 2.89-3.172 3.969 2.938 3.477 12.267 1.803 16.34l-.082.188zM3.527 14.053c7.339-1.557 14.303-5.08 20.425-9.47.398-.292 1.135-.935.89-1.404-.118-.187-.457-.175-.797-.023-6.156 4.202-12.758 7.737-19.956 9.61-.586.093-1.65.995-.726 1.275h.176z"
        />
      </svg>
    );
  }
);

TrendUp.displayName = 'TrendUp';

export { TrendUp };
